// extracted by mini-css-extract-plugin
export default {"dialog":"ContactDialog_dialog__e5fNK"};